<template>
	<div class="foot-container flex-center">
		<div style="height: 160px;">
			<el-image src="/static/img/icon/blue.png" style="width: 65px;height: 65px;margin-right: 0px;"></el-image>
		</div>
		<div>
			<div class="flex-center">
				<span class="pv-title">总访问量</span>
				<span v-for="num in pvList" class="pv-item flex-center">{{num}}</span>
			</div>
			<p class="footer-item-text">版权所有：晋冀鲁豫烈士陵园</p>
			<p class="footer-item-text">地址：河北省邯郸市邯山区陵园路60号 0310-3022896</p>
			<p class="footer-item-text">版权所有：冀ICP备18023326号-1号 冀公安网备13040202000690</p>
		</div>
		<div style="margin-left: 37px;">
			<el-image src="/static/img/foot-view/gzh.jpg" style="width: 80px;height: 80px;"></el-image>
		</div>
	</div>
</template>

<script>
	import api from '@/http/common'
	export default {
		name: "Footer",
		data() {
			return {
				pvList: [3]
			}
		},
		methods: {
			getPv() {
				const _this = this;
				api.getPv().then(res => {
					var pv = res + "";
					_this.pvList = pv.split("");
				})
			}
		},
		created() {
			this.getPv();
		}
	};
</script>

<style scoped>
	.foot-container {
		height: 280px;
		background: #363636;
	}

	.pv-title {
		width: 65px;
		height: 16px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #E5E5E5;
		line-height: 16px;
		margin-right: 15px;
		margin-left: -80px;
	}

	.pv-item {
		width: 37px;
		height: 33px;
		background: rgba(54, 54, 54, 0.34);
		border: 1px solid #FFFFFF;
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 24px;
		margin-left: 7px;
	}

	.footer-item-text {
		height: 16px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 24px;
		margin-top: 25px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue